interface IOverlayState {
  show?: boolean;
}

const actions = {
  SHOW: 'lms-ui/overlay/SHOW',
};

interface IOverlayAction {
  type: typeof actions.SHOW;
  payload?: boolean;
}

type OverlayActionTypes = IOverlayAction;

const initialState: IOverlayState = {
  show: false,
};

export const showOverlay = (show?: boolean): OverlayActionTypes => {
  return { type: actions.SHOW, payload: show };
};

export default function reducer(state = initialState, action: OverlayActionTypes): IOverlayState {
  switch (action.type) {
    case actions.SHOW: {
      return {
        ...state,
        show: action.payload,
      };
    }
    default:
      return state;
  }
}
